import { __ } from '@wordpress/i18n';
import { TextControl, TextareaControl, ToggleControl } from "@wordpress/components";
import { produce } from 'immer';

// Custom Components
import { InlineDetailMediaUpload, Label } from '../../../../../bpl-tools/Components';
import { BControlPro } from '../../../../bplugins_sdk/src/components/v1';

const Item = ({ attributes, setAttributes, arrKey, index, setActiveIndex = false, premiumProps }) => {
    const sliders = attributes[arrKey];
    const { title, img, desc, btnLabel, btnUrl, target, altText } = sliders[index];

    const updateSlider = (type, val, childType = false) => {
        const newSlider = produce(sliders, draft => {
            if (childType) {
                draft[index][type][childType] = val;
            } else {
                draft[index][type] = val;
            }
        });
        setAttributes({ sliders: newSlider });
    }

    return <>
        <div key={index} className="components_button_main" onClick={() => setActiveIndex(index)}>
            <Label>{__('Slide Image:', 'slider')}</Label>

            <InlineDetailMediaUpload value={img} types={['image']} onChange={val => updateSlider('img', val)} placeholder={__('Enter Image URL', 'slider')} />

            <TextControl label={__("Image Alt", 'slider')} labelPosition={__('top', 'slider')} value={altText != null ? altText : img?.caption || img?.title} placeholder={__('Enter Image Alt Text', 'slider')} onChange={val => updateSlider('altText', val)} />

            <TextControl label={__("Title", 'slider')} labelPosition={__('top', 'slider')} value={title != null ? title : img?.caption || img?.title} placeholder={__('Enter Title', 'slider')} onChange={val => updateSlider('title', val)} />

            <TextareaControl label={__("Description", 'slider')} labelPosition={__('top', 'slider')} value={desc} placeholder={__('Enter desc', 'slider')} onChange={val => updateSlider('desc', val)} />

            <BControlPro label={__("Button label", 'slider')} labelPosition={__('top', 'slider')} value={btnLabel} placeholder={__('Enter Label', 'slider')} onChange={val => updateSlider('btnLabel', val)} Component={TextControl} {...premiumProps} />

            <BControlPro label={__("Button Url", 'slider')} labelPosition={__('top', 'slider')} value={btnUrl} placeholder={__('Enter Url', 'slider')} onChange={val => updateSlider('btnUrl', val)} Component={TextControl} {...premiumProps} />

            <BControlPro className='mt20' label={__('Open in new tab', 'slider')} checked={target} onChange={(val) => updateSlider('target', val)} Component={ToggleControl} {...premiumProps} />
        </div>
    </>
}

export default Item;